import ContractDabangBanner from "../../../../src/events/2023/01/contract-banner/main";
import * as React from 'react';
export default {
  ContractDabangBanner,
  React
};